import OTPublishersNativeSDK from 'react-native-onetrust-cmp';

import platformConfig from '/config/platform.config';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics';
import {isProdEnvironment} from '/util/env.util';
import {getFullStoryUtilDefaultInstance} from '/util/fullstory';
import {error as consoleError, log} from '/util/logger.util';
import {getPerfMonitorDefaultInstance} from '/util/perf-monitor/perf-monitor.util';
import {getQualtricsDefaultInstance} from '/util/qualtrics';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {
  FIREBASE_PERF_SDK_ID,
  FIREBASE_SDK_ID,
  FULLSTORY_SDK_ID,
  getAppID,
  QUALTRICS_SDK_ID,
  TEALIUM_SDK_ID,
} from './skdID.constant';

// Set this to `true` to enable console logging of OneTrust events.
// Do NOT commit that change into the repo.
const LOG_ONETRUST = false;

export class OneTrustConfig {
  ATTConsent: any;

  isInitialized: any;

  isTealiumInitialized: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;

    this.isInitialized = false;
    this.ATTConsent = false;
    this.isTealiumInitialized = false;
  }

  // Initializes the oneTrust instance
  initialize() {
    // Make sure that Analytics instance will be initialized
    getAnalyticsUtilDefaultInstance();
    OTPublishersNativeSDK.startSDK(
      'cdn.cookielaw.org',
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      getAppID(),
      'en',
      {},
      // Don't show OneTrust Banner on initializing for ios
      platformConfig.select({ios: false, android: true}),
    )
      .then(_responseObject => {
        this.isInitialized = true;

        OTPublishersNativeSDK.getConsentStatusForSDKId(FULLSTORY_SDK_ID).then(
          result => {
            if (this.verbose) {
              log(
                '[OneTrust] Get consent Status for FULLSTORY_SDK_ID = ' +
                  result,
              );
            }
            if (result === 1 && this.ATTConsent && isProdEnvironment()) {
              getFullStoryUtilDefaultInstance().enable();
            } else {
              getFullStoryUtilDefaultInstance().shutdown();
            }
          },
        );

        OTPublishersNativeSDK.getConsentStatusForSDKId(
          FIREBASE_PERF_SDK_ID,
        ).then(result => {
          if (this.verbose) {
            log(
              '[OneTrust] Get consent Status for FIREBASE_PERF_SDK_ID = ' +
                result,
            );
          }
          if (result === 1 && this.ATTConsent) {
            getPerfMonitorDefaultInstance().enableDataCollection();
          } else {
            getPerfMonitorDefaultInstance().disableDataCollection();
          }
        });

        // TODO: Add Qualtrics correct integration with consent policy
        OTPublishersNativeSDK.getConsentStatusForSDKId(QUALTRICS_SDK_ID).then(
          result => {
            if (this.verbose) {
              log(
                '[OneTrust] Get consent Status for QUALTRICS_SDK_ID = ' +
                  result,
              );
            }
            if (result === 1 && this.ATTConsent) {
              getQualtricsDefaultInstance().setConsent(true);
            } else {
              getQualtricsDefaultInstance().setConsent(false);
            }
          },
        );

        OTPublishersNativeSDK.getConsentStatusForSDKId(FIREBASE_SDK_ID).then(
          result => {
            if (this.verbose) {
              log(
                '[OneTrust] Get consent Status for FIREBASE_SDK_ID = ' + result,
              );
            }
            if (result === 1 && this.ATTConsent) {
              getAnalyticsUtilDefaultInstance().enableAnalyticsCollection();
            } else {
              getAnalyticsUtilDefaultInstance().disableAnalyticsCollection();
            }
          },
        );

        OTPublishersNativeSDK.getConsentStatusForSDKId(TEALIUM_SDK_ID).then(
          result => {
            if (this.verbose) {
              log(
                '[OneTrust] Get consent Status for TEALIUM_SDK_ID = ' + result,
              );
            }
            if (this.ATTConsent) {
              if (!this.isTealiumInitialized) {
                getTealiumUtilDefaultInstance().initialize();
                this.isTealiumInitialized = true;
                if (result === 1) {
                  getTealiumUtilDefaultInstance().enable();
                } else {
                  getTealiumUtilDefaultInstance().disable();
                }
              }
            }
          },
        );

        OTPublishersNativeSDK.setBroadcastAllowedValues([
          TEALIUM_SDK_ID,
          FIREBASE_SDK_ID,
          QUALTRICS_SDK_ID,
          FIREBASE_PERF_SDK_ID,
          FULLSTORY_SDK_ID,
        ]);

        OTPublishersNativeSDK.listenForConsentChanges(
          FULLSTORY_SDK_ID,
          (id, status) => {
            if (this.verbose) {
              log(
                '[OneTrust] Consent status for FULLSTORY_SDK_ID',
                id,
                ' has been updated to ',
                status,
              );
            }
            if (status === 1 && this.ATTConsent && isProdEnvironment()) {
              getFullStoryUtilDefaultInstance().enable();
            } else {
              getFullStoryUtilDefaultInstance().shutdown();
            }
          },
        );

        OTPublishersNativeSDK.listenForConsentChanges(
          FIREBASE_PERF_SDK_ID,
          (id, status) => {
            if (this.verbose) {
              log(
                '[OneTrust] Consent status for FIREBASE_PERF_SDK_ID',
                id,
                ' has been updated to ',
                status,
              );
            }
            if (status === 1 && this.ATTConsent) {
              getPerfMonitorDefaultInstance().enableDataCollection();
            } else {
              getPerfMonitorDefaultInstance().disableDataCollection();
            }
          },
        );

        // TODO: Add Qualtrics correct integration with consent policy
        OTPublishersNativeSDK.listenForConsentChanges(
          QUALTRICS_SDK_ID,
          (id, status) => {
            if (this.verbose) {
              log(
                '[OneTrust] Consent status for QUALTRICS_SDK',
                id,
                ' has been updated to ',
                status,
              );
            }
            if (status === 1 && this.ATTConsent) {
              getQualtricsDefaultInstance().setConsent(true);
            } else {
              getQualtricsDefaultInstance().setConsent(false);
            }
          },
        );

        OTPublishersNativeSDK.listenForConsentChanges(
          TEALIUM_SDK_ID,
          (id, status) => {
            if (this.verbose) {
              log(
                '[OneTrust] Consent status for TEALIUM_SDK_ID',
                id,
                ' has been updated to ',
                status,
              );
            }
            if (this.ATTConsent) {
              if (!this.isTealiumInitialized) {
                getTealiumUtilDefaultInstance().initialize();
              }
              this.isTealiumInitialized = true;
              if (status === 1) {
                getTealiumUtilDefaultInstance().enable();
              } else {
                getTealiumUtilDefaultInstance().disable();
              }
            }
          },
        );

        OTPublishersNativeSDK.listenForConsentChanges(
          FIREBASE_SDK_ID,
          (id, status) => {
            if (this.verbose) {
              log(
                '[OneTrust] Consent status for FIREBASE_SDK_ID',
                id,
                ' has been updated to ',
                status,
              );
            }
            if (status === 1 && this.ATTConsent) {
              getAnalyticsUtilDefaultInstance().enableAnalyticsCollection();
            } else {
              getAnalyticsUtilDefaultInstance().disableAnalyticsCollection();
            }
          },
        );
      })
      .catch(error => {
        consoleError(`OneTrust download failed with error ${error}`);
      });
  }

  setATTConsent(status: any) {
    this.ATTConsent = status;
  }

  showBanner() {
    OTPublishersNativeSDK.showPreferenceCenterUI();
  }
}

let OneTrustUtilDefaultInstance: any = null;

export const getOneTrustUtilDefaultInstance = () => {
  if (OneTrustUtilDefaultInstance === null) {
    OneTrustUtilDefaultInstance = new OneTrustConfig({
      verbose: LOG_ONETRUST,
    });
  }

  return OneTrustUtilDefaultInstance;
};
